<template>
    <span
        :uk-tooltip="
            disabled
                ? 'title:' + $t('x.module.disabled.hint', {x: $t('whiteLabel')})
                : ''
        "
        :class="disabled ? 'module-disabled-struct' : ''">
        <span
            :class="
                disabled ? 'module-disabled uk-height-1-1' : 'uk-height-1-1'
            ">
            <Card
                :title="$t(title)"
                is-dark
                mode="default"
                class="uk-height-1-1">
                <Description v-if="description" :text="$t(description)" />

                <LabelWithError :label="$t('button.background.color')" />

                <sketch-picker v-model="colorValue" />

                <div class="uk-margin-medium-top" />
                <LabelWithError :label="$t('button.text.color')" />
                <div class="uk-grid-small" uk-grid>
                    <div v-for="mode in ['bright', 'dark']" :key="mode">
                        <span v-on:click="colorMode = mode">
                            <LabelSelect :is-selected="mode === colorMode">
                                <Translate :translation-key="mode" />
                            </LabelSelect>
                        </span>
                    </div>
                </div>

                <div class="uk-margin-medium-top" />
                <LabelWithError :label="$t('preview')" />

                <Button
                    id="preview"
                    with-class="lunacart-theme-background lunacart-theme-color"
                    is-round
                    mode="info">
                    <Translate translation-key="preview.test" />
                </Button>

                <hr />

                <div class="uk-margin-medium-bottom" />
                <Button
                    :action="actionUpdate"
                    :is-loading="loading"
                    :text="$t('x.save', {x: $t(title)})"
                    has-action
                    is-large
                    is-max
                    mode="primary" />

                <div v-if="error" class="uk-margin-medium-bottom" />
                <ErrorMessage :error="error" />

                <div v-if="success" class="uk-margin-medium-bottom" />
                <SuccessMessage
                    :success="success"
                    :message="$t('x.changes.saved', {x: $t(title)})" />
            </Card>
        </span>
    </span>
</template>

<script>
import SuccessMessage from '@/components/generic/SuccessMessage.vue';
import Description from '@/components/Description.vue';
import Button from '@/components/generic/Button.vue';
import Card from '@/components/generic/Card.vue';
import ErrorMessage from '@/components/generic/ErrorMessage.vue';
import axios from 'axios';
import {Sketch} from 'vue-color';
import LabelWithError from '@/components/generic/LabelWithError.vue';
import LabelSelect from '@/components/LabelSelect.vue';
import Translate from '@/components/Translate.vue';

export default {
    name: 'ClickAndBuyColorForm',
    components: {
        Translate,
        LabelSelect,
        LabelWithError,
        ErrorMessage,
        Card,
        Button,
        Description,
        SuccessMessage,
        'sketch-picker': Sketch,
    },
    props: {
        text: String,
        disabled: Boolean,
        mode: String,
    },
    watch: {
        colorMode(oldVal, newVal) {
            if (oldVal !== newVal) {
                this.success = false;
            }

            this.setLunacartThemeColors(
                this.colorValue.hex,
                this.colorMode === 'dark' ? '#333' : '#fff'
            );
        },
        colorValue(oldVal, newVal) {
            if (oldVal !== newVal) {
                this.success = false;
            }

            this.setLunacartThemeColors(
                this.colorValue.hex,
                this.colorMode === 'dark' ? '#333' : '#fff'
            );
        },
    },
    data() {
        return {
            title: 'button.theme.color',
            description: '',

            loading: false,
            success: false,
            error: null,

            colorValue: {hex: this.text ?? ''},
            colorMode: this.mode,
        };
    },
    mounted() {
        let self = this;
        let intervalId = setInterval(function () {
            const successElement = document.getElementById('preview');
            if (!successElement) {
                return;
            }

            clearInterval(intervalId);

            self.setLunacartThemeColors(
                 self.colorValue.hex,
                self.colorMode === 'dark' ? '#333' : '#fff'
            );
        }, 10);
    },
    methods: {
        actionUpdate() {
            this.loading = true;

            let backgroundColor = this.colorValue.hex.toLowerCase();
            if (!backgroundColor.startsWith('#')) {
                backgroundColor = '#' + backgroundColor;
            }

            let http = axios.create();
            http.put(this.apiUrl + '/manage-clickandbuys/color', {
                backgroundColor: backgroundColor,
                colorMode: this.colorMode,
            })
                .then(() => {
                    this.error = null;
                    this.success = true;
                    this.loading = false;

                    this.$emit('updated');
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                    this.success = false;
                    this.loading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped></style>
